import { HeatmapCellClickPayload } from '@frontend/chart/components';

export interface InsightHeatmapCellTimeWindow {
    after: string;
    before: string;
}

/** UTC day window `[date 00:00, next day 00:00)`. */
export const weekdayHeatmapCellWindow = (date: string): InsightHeatmapCellTimeWindow | null => {
    const start = new Date(`${date}T00:00:00.000Z`);
    if (Number.isNaN(start.getTime())) {
        return null;
    }

    const end = new Date(start);
    end.setUTCDate(end.getUTCDate() + 1);

    return {
        after: start.toISOString(),
        before: end.toISOString()
    };
};

/** UTC hour window `[date hour:00, date hour+1:00)`. */
export const hourDayHeatmapCellWindow = (date: string, hour: number): InsightHeatmapCellTimeWindow | null => {
    if (!Number.isInteger(hour) || hour < 0 || hour > 23) {
        return null;
    }

    const start = new Date(`${date}T${String(hour).padStart(2, '0')}:00:00.000Z`);
    if (Number.isNaN(start.getTime())) {
        return null;
    }

    const end = new Date(start);
    end.setUTCHours(end.getUTCHours() + 1);

    return {
        after: start.toISOString(),
        before: end.toISOString()
    };
};

/** Build the list query window for a heatmap cell click. */
export const insightHeatmapCellWindow = (cell: HeatmapCellClickPayload): InsightHeatmapCellTimeWindow | null => {
    if (typeof cell.hour === 'number') {
        return hourDayHeatmapCellWindow(cell.date, cell.hour);
    }

    return weekdayHeatmapCellWindow(cell.date);
};
